import { render, staticRenderFns } from "./ProcedurePlanUnsubscribeQ.vue?vue&type=template&id=2c55569a&"
import script from "./ProcedurePlanUnsubscribeQ.vue?vue&type=script&lang=ts&"
export * from "./ProcedurePlanUnsubscribeQ.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports